import { createReducer } from '@reduxjs/toolkit';

import defaultState from './defaultState';
import { reducer as listProductVendorsReducer } from './list';
import { reducer as createProductVendorReducer } from './create';
import { reducer as renameProductVendorReducer } from './rename';
import { reducer as deleteProductVendorReducer } from './delete';

const productVendorsReducer = createReducer(
  defaultState,
  (builder) => {
    listProductVendorsReducer(builder);
    createProductVendorReducer(builder);
    renameProductVendorReducer(builder);
    deleteProductVendorReducer(builder);
  },
);

export default productVendorsReducer;
